export const constructionSettingCodeList = {
  BankTypes: [
    { label: "台灣銀行", value: "BOT" },
    { label: "華南商業銀行", value: "HNCB" }
  ]
};
